import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

interface Props {
  ref: React.RefObject<HTMLDivElement>;
  isLoading: boolean;
}

const measureHeaderHeight = (element: HTMLElement) => element.getBoundingClientRect().height;

export const useHeaderHeight = ({ ref, isLoading }: Props) => {
  const [headerHeight, setHeaderHeight] = useState(0);

  const updateHeaderHeight = useCallback(() => {
    if (ref?.current) setHeaderHeight(measureHeaderHeight(ref.current));
  }, [ref]);

  useEffect(() => {
    updateHeaderHeight();

    window.addEventListener('resize', updateHeaderHeight);
    return () => window.removeEventListener('resize', updateHeaderHeight);
  }, [updateHeaderHeight]);

  useLayoutEffect(() => {
    if (!isLoading && ref?.current) {
      setHeaderHeight(measureHeaderHeight(ref.current));
    }
  }, [ref, isLoading]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new ResizeObserver(() => updateHeaderHeight());
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, updateHeaderHeight]);

  return headerHeight;
};
